import React, { useState, useRef, useEffect } from 'react';
import Navbar from './Navbar/Navbar';
import ApiCollections from '../Sidebar/ApiCollections';
import HistoryPanel from '../History/HistoryPanel';

export default function Layout({ children, history, setHistory, setSelectedRequest }) {
  const [leftWidth, setLeftWidth] = useState(320);
  const [rightWidth, setRightWidth] = useState(320);
  const [isResizingLeft, setIsResizingLeft] = useState(false);
  const [isResizingRight, setIsResizingRight] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizingLeft) {
        const newWidth = e.clientX;
        if (newWidth >= 250 && newWidth <= 500) {
          setLeftWidth(newWidth);
        }
      }
      if (isResizingRight) {
        const containerWidth = containerRef.current?.offsetWidth || window.innerWidth;
        const newWidth = containerWidth - e.clientX;
        if (newWidth >= 250 && newWidth <= 500) {
          setRightWidth(newWidth);
        }
      }
    };

    const handleMouseUp = () => {
      setIsResizingLeft(false);
      setIsResizingRight(false);
      document.body.style.cursor = 'default';
      document.body.style.userSelect = 'auto';
    };

    if (isResizingLeft || isResizingRight) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'ew-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizingLeft, isResizingRight]);

  return (
    <>
      <Navbar />
      <div ref={containerRef} className="flex h-screen pt-[60px] overflow-hidden">
        {/* Left Panel */}
        <div style={{ width: `${leftWidth}px` }} className="flex-shrink-0 relative">
          <ApiCollections onRequestSelect={setSelectedRequest} />
          {/* Right Resize Handle */}
          <div
            className="absolute top-0 right-0 w-1 h-full cursor-ew-resize hover:bg-[#fdb814] transition-colors group"
            onMouseDown={() => setIsResizingLeft(true)}
          >
            <div className="absolute top-1/2 right-0 transform translate-x-1/2 -translate-y-1/2 w-1 h-12 bg-gray-300 rounded-full group-hover:bg-[#fdb814] transition-colors"></div>
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-hidden bg-gradient-to-br from-gray-50 via-white to-gray-50 flex flex-col">
          <div className="w-full h-full flex flex-col p-6">{children}</div>
        </main>

        {/* Right Panel */}
        <div style={{ width: `${rightWidth}px` }} className="flex-shrink-0 relative">
          {/* Left Resize Handle */}
          <div
            className="absolute top-0 left-0 w-1 h-full cursor-ew-resize hover:bg-[#fdb814] transition-colors group"
            onMouseDown={() => setIsResizingRight(true)}
          >
            <div className="absolute top-1/2 left-0 transform -translate-x-1/2 -translate-y-1/2 w-1 h-12 bg-gray-300 rounded-full group-hover:bg-[#fdb814] transition-colors"></div>
          </div>
          <HistoryPanel history={history} setHistory={setHistory} />
        </div>
      </div>
    </>
  );
}